import React from 'react';
import { AlertTriangle } from 'lucide-react';

const EducationProblem = () => {
  const challenges = [
    'Distributed campuses and departments',
    'High onboarding volume and turnover',
    'Safety and crisis scenarios that can\'t be "checked off" with a video',
    'Sensitive, high-stakes communication with families and communities'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xl text-gray-300 mb-8">
            Traditional LMS platforms weren't built for today's realities:
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="space-y-4">
            {challenges.map((challenge, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-red-900/20 to-orange-900/20 border border-red-500/30"
              >
                <AlertTriangle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{challenge}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center">
          <div className="p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-xl text-white font-semibold">
              Traain provides the enablement infrastructure districts need to prepare staff for real-world situations — not just compliance completion.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationProblem;
